import { Link } from "react-router-dom";
import { Wordmark } from "@/components/primitives";

export default function NotFound() {
  return (
    <main className="flex min-h-[100dvh] flex-col items-center justify-center gap-6 px-5 text-center">
      <Wordmark className="text-[18px] text-ink-dim" />
      <div className="flex gap-1.5">
        {["4", "0", "4"].map((letter, i) => (
          <span key={i} className="tile tile-miss text-[24px]" style={{ width: 52, height: 52 }}>
            {letter}
          </span>
        ))}
      </div>
      <p className="text-[15px] text-ink-dim">Nothing here. Rooms die with the server.</p>
      <Link to="/" className="btn btn-ghost">
        Back to the start
      </Link>
    </main>
  );
}
